import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { PaymentComp } from 'components/forms'
import { wizard, meta } from 'helpers/decorators'
import validate from './choose-payment.validation'
import { apiParticipants } from 'helpers/decorators/api'
import { Button, FormDebug } from 'components/misc'

const enhance = compose(
  meta({
    title: 'Register participant',
    intlKey: 'pageTitle.register_participant'
  }),
  apiParticipants(),
  wizard({
    form: 'participantRegistration',
    multipage: true,
    destroyOnUnmount: false,
    validate
  })
)

class Level extends Component {
  static propTypes = {
    errors: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    onPaymentInitialization: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    values: PropTypes.object,
    paymentOptions: PropTypes.object
  }

  render() {
    const {
      onPaymentInitialization,
      handleSubmit,
      onSubmit,
      values,
      change,
      errors,
      paymentOptions
    } = this.props

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        data-testId="registrationPaymentForm"
      >
        <PaymentComp
          onPaymentInitialization={onPaymentInitialization}
          change={change}
          paymentOptions={paymentOptions}
          errors={errors}
          values={values}
        />
        <FormDebug {...this.props} />
        <Button>
          <FormattedMessage id="button.continue" defaultMessage="Continue" />
        </Button>
      </form>
    )
  }
}

export default enhance(Level)
